export default __webpack_public_path__ + "static/media/dos.4cc654a6.svg";